// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__1KVxd","animateRoot":"header_animateRoot__2WmVL","back":"header_back__1Oazz","cta":"header_cta__sHC4T"};